import { useEffect, useState } from "react";
import { SimulationEhrSequence } from "models/ui";
import { AppConstant } from "constants/app.constant";
import { apiHelper } from "helpers";
import { simulationService } from "services";
import AssignmentCommonInfo from "../assignment-common-info/AssignmentCommonInfo";
import { useParams } from "react-router";

type Params = {
    assessmentId?: string;
}

const SimulationEhrPanel: React.FC = (props) => {
    const [sequenceChunk, setSequenceChunk] = useState<SimulationEhrSequence>(null);
    const params = useParams<Params>();
    const assessmentId = params.assessmentId;
    const phaseId = localStorage.getItem(AppConstant.PHASE_ID);

    useEffect(() => {
      const fetchData = async () => {
        try {
          const res = await simulationService.getCurrentOrFirstSequenceChunk(Number(assessmentId), phaseId);
          setSequenceChunk(res?.data);
        } catch (err) {
          apiHelper.showApiError(`can not load data ${err}`);
        }
      };
      fetchData();
    }, []);
  return sequenceChunk ? <AssignmentCommonInfo assessmentId={assessmentId} sequenceChunk={sequenceChunk} /> : null
};

export default SimulationEhrPanel;